<template>
  <v-dialog v-model="dialog" width="80%">
    <CSRFToken @loaded="csrf_token" v-model="getCSRFToken" />
    <v-card class="change-password-container">
      <v-card-title class="change-password-title">Alterar senha</v-card-title>
      <v-form
        class="change-password-form"
        :outline="false"
        v-model="formularioValido"
        method="POST"
      >
        <p v-show="mensagemErro" class="change-password-error">
          {{ mensagemErro }}
        </p>

        <v-text-field
          outlined
          :append-icon="mostrarSenhaAtual ? 'fa-eye' : 'fa-eye-slash'"
          @click:append="mostrarSenhaAtual = !mostrarSenhaAtual"
          :type="mostrarSenhaAtual ? 'text' : 'password'"
          class="mt-2"
          label="Senha atual"
          maxlength="128"
          autofocus
          v-model="senhaAtual"
          :rules="[rules.required]"
          :error="Boolean(mensagemErro)"
          @input="mensagemErro = ''"
        />

        <hr class="separadorModalSenha mb-6" />

        <v-text-field
          outlined
          :append-icon="mostrarSenhaNova ? 'fa-eye' : 'fa-eye-slash'"
          @click:append="mostrarSenhaNova = !mostrarSenhaNova"
          :type="mostrarSenhaNova ? 'text' : 'password'"
          :disabled="loading"
          class="mb-0"
          label="Nova senha"
          hint="A senha deve conter no mínimo 8 caracteres entre letras maiúsculas, minúsculas e caracteres especiais"
          minlength="8"
          maxlength="128"
          name="senha"
          counter
          v-model="senha"
          :rules="[rules.required, rules.counterMax, rules.padraoSenhaValido]"
        />
        <v-text-field
          outlined
          :append-icon="mostrarConfirmarSenha ? 'fa-eye' : 'fa-eye-slash'"
          @click:append="mostrarConfirmarSenha = !mostrarConfirmarSenha"
          :type="mostrarConfirmarSenha ? 'text' : 'password'"
          :disabled="senha.length < 8 || loading"
          class="mb-3 mt-2"
          label="Confirmar senha"
          maxlength="128"
          counter
          v-model="confirmarSenha"
          :rules="[rules.equal, rules.required]"
          :hide-details="false"
        />
      </v-form>
      <v-card-actions class="change-password-actions">
        <v-spacer></v-spacer>
        <p-button
          icon="fa-xmark"
          iconSize="small"
          :colorful="false"
          text
          :onClick="() => (dialog = false)"
          label="Cancelar"
        />
        <p-button
          icon="fa-check"
          class="rounded-lg botaoDeAlterarSenha"
          iconSize="small"
          label="Atualizar senha"
          :colorful="true"
          :loading="loading"
          :onClick="() => alterarSenha()"
          :disabled="!formularioValido || loading"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PButton from "../PButton/PButton.vue";

import senhaService from "../../api/senha";

import CSRF from "../../api/csrfMixin";
import CSRFToken from "../CSRFToken/CSRFToken.vue";

import { store } from "../../api/store";

export default {
  components: {
    PButton,
    CSRFToken,
  },

  mixins: [CSRF()],

  data() {
    return {
      dialog: this.value,

      mostrarSenhaAtual: false,
      mostrarSenhaNova: false,
      mostrarConfirmarSenha: false,

      senhaAtual: "",
      senha: "",
      confirmarSenha: "",

      senhaValida: false,
      loading: false,
      formularioValido: false,
      getCSRFToken: true,

      mensagemErro: "",
      rules: {
        counterMax: (value) =>
          value.length <= 128 || "No máximo 128 caracteres.",
        padraoSenhaValido: (value) =>
          this.validarSenha(value) ||
          "A senha deve conter no mínimo 8 caracteres entre letras maiúsculas, minúsculas e caracteres especiais",
        required: (value) => !!value || "Senha é obrigatória.",
        equal: () =>
          this.senha === this.confirmarSenha || "As senhas devem ser iguais",
      },
    };
  },

  props: ["value"],

  methods: {
    validarSenha: function (senha) {
      const padraoSenha = new RegExp(
        /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[$*!?&@#])[0-9a-zA-Z$*!?&@#]{8,}$/
      );
      return padraoSenha.test(senha);
    },

    async alterarSenha() {
      this.loading = true;

      try {
        await senhaService.API.Actions.alterar(
          this.senha,
          this.senhaAtual,
          this._token
        );

        store.dispatch("logoff");
      } catch (err) {
        this.getCSRFToken = !this.getCSRFToken;

        if (err.response.status === 406) {
          this.mensagemErro = err.response.data.error;
          return;
        }

        if (err.response.status === 422) {
          this.mensagemErro = "Formato de senha inválido";
          return;
        }

        if (err.response.status === 422) {
          this.mensagemErro = "Tivemos um problema, tente novamente";
          return;
        }

        if (err.response.status === 401) {
          store.dispatch("logoff");
        }
      } finally {
        this.loading = false;
      }
    },
  },

  watch: {
    value: function () {
      this.dialog = this.value;
    },
  },
};
</script>

<style scoped>
.change-password-container {
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
}

.change-password-title {
  width: 100%;

  text-align: center;
  justify-content: center;

  background-color: var(--v-accent-base);
  color: var(--v-secondary-base);

  font-size: 1.5rem !important;
  font-weight: 600 !important;
}

.change-password-form {
  width: 90%;

  margin-top: 30px;
}

.change-password-error {
  font-size: 1.3rem !important;
  font-weight: 600 !important;

  color: var(--v-error-base);
}

.change-password-actions {
  width: 90%;

  justify-content: flex-end;

  padding: 10px 0 20px !important;

  font-size: 1.5rem !important;
  font-weight: 600 !important;
}
</style>
